import { useQuery } from '@tanstack/react-query';
import { EncounterSummary, EncounterSummaryType } from 'src/models';
import { ambientApi } from 'src/services';
import { UseQueryOverrideOptions } from '../common';

export type UseGetSummaryListParams = {
  encounterId?: string;
  encounterPhase?: EncounterSummary['encounter_phase'] | null;
  serviceRequestId?: string;
  type?: EncounterSummaryType;
  page?: number;
  pageSize?: number;
};

export type GetSummaryListResponse = {
  summaries: EncounterSummary[];
};

export const useGetSummaryList = (
  params: UseGetSummaryListParams,
  options?: UseQueryOverrideOptions<GetSummaryListResponse>
) => {
  const {
    encounterId,
    encounterPhase,
    serviceRequestId,
    type,
    page,
    pageSize,
  } = params;

  return useQuery({
    ...options,
    queryKey: ['summaryList', params],
    queryFn: () =>
      ambientApi
        .get<GetSummaryListResponse>('/summaries', {
          params: {
            encounter_id: encounterId,
            encounter_phase: encounterPhase,
            service_request_id: serviceRequestId,
            type,
            page,
            page_size: pageSize,
          },
        })
        .then((res) => res.data),
  });
};
